import { UserDto } from '@ebf/features/users/domain';

export const getUserFullName = (user: Partial<UserDto>): string =>
  [user?.firstName, user?.lastName].filter(Boolean).join(' ');
